import axios from "axios";
import Config from "../../config/index";
import RefreshTokenHandler from "./refresh-token";
import { toast } from "react-toastify";
import apiClient from "../../utils/apiClient";

const getAllDividendAnnouncements = async (
  email: string,
  amc_code: string,
  fund_code?: string
) => {
  const url = `${Config.baseUrl}/corporateannouncements?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllDividendAnnouncements(email, amc_code, fund_code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const postToDividendAnnouncement = async (
  email: string,
  amc_code: any,
  fund: any,
  announcementId: any,
  announcement_number: any,
  announcementDescription: any,
  // date: any,
  redemptionDate: any,
  openingExNav: any,
  closingNavBeforeDistribution: any,
  payoutRatio: any,
  dividendPerUnit: any,
  exNavAfterDistribution: any,
  fromDate: any,
  toDate: any,
  bankAccountDetails?: any
) => {
  const url = `${Config.baseUrl}/corporateannouncements`;
  const token = sessionStorage.getItem("token");
  try {
    const result: any = await axios.post(
      url,
      {
        email,
        amc_code: amc_code,
        fund_code: fund,
        announcement_id: announcementId,
        announcement_number,
        description: announcementDescription,
        redemption_date: redemptionDate,
        opening_ex_nav: parseFloat(openingExNav).toFixed(4).toString(),
        closing_nav_before_dist: parseFloat(closingNavBeforeDistribution)
          .toFixed(4)
          .toString(),
        payout_ratio_percent: payoutRatio,
        dividend_per_unit: parseFloat(dividendPerUnit).toFixed(4).toString(),
        ex_nav_after_dist: parseFloat(exNavAfterDistribution)
          .toFixed(4)
          .toString(),
        paid: "false",
        from_date: fromDate,
        to_date: toDate,
        bankAccountDetails,
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );

    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await postToDividendAnnouncement(
          email,
          amc_code,
          fund,
          announcementId,
          announcement_number,
          announcementDescription,
          // date,
          redemptionDate,
          openingExNav,
          closingNavBeforeDistribution,
          payoutRatio,
          dividendPerUnit,
          exNavAfterDistribution,
          fromDate,
          toDate
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const changeActiveStatus = async (
  email: string,
  announcement_id: any,
  status: any
) => {
  const url = `${Config.baseUrl}/corporateannouncements/update-status`;
  const token = sessionStorage.getItem("token") || "";

  try {
    const result = await axios.post(
      url,
      { email, announcement_id, status },
      { headers: { Authorization: token } }
    );

    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await changeActiveStatus(email, announcement_id, status);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const changePaidStatus = async (
  email: string,
  announcement_id: any,
  paid: any
) => {
  const url = `${Config.baseUrl}/corporateannouncements/update-paid-status`;
  const token = sessionStorage.getItem("token") || "";

  try {
    const result = await axios.post(
      url,
      { email, announcement_id, paid },
      { headers: { Authorization: token } }
    );

    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await changePaidStatus(email, announcement_id, paid);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const updateDividendAnnouncement = async (
  email: string,
  announementId: any,
  amc_code: any,
  fund: any,
  announcementDescription: any,
  date: any,
  redemptionDate: any,
  openingExNav: any,
  closingNavBeforeDistribution: any,
  payoutRatio: any,
  dividendPerUnit: any,
  exNavAfterDistribution: any,
  fromDate: any,
  toDate: any,
  bankAccountDetails?: any
) => {
  const url = `${Config.baseUrl}/corporateannouncements/update`;
  const token = sessionStorage.getItem("token");
  try {
    const result: any = await axios.post(
      url,
      {
        email,
        announcement_id: announementId,
        amc_code: amc_code,
        fund_code: fund,
        description: announcementDescription,
        redemption_date: redemptionDate,
        opening_ex_nav: parseFloat(openingExNav).toFixed(4).toString(),
        closing_nav_before_dist: parseFloat(closingNavBeforeDistribution)
          .toFixed(4)
          .toString(),
        payout_ratio_percent: payoutRatio,
        dividend_per_unit: parseFloat(dividendPerUnit).toFixed(4).toString(),
        ex_nav_after_dist: parseFloat(exNavAfterDistribution)
          .toFixed(4)
          .toString(),
        paid: "false",
        from_date: fromDate,
        to_date: toDate,
        bankAccountDetails,
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );

    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await updateDividendAnnouncement(
          email,
          announementId,
          amc_code,
          fund,
          announcementDescription,
          date,
          redemptionDate,
          openingExNav,
          closingNavBeforeDistribution,
          payoutRatio,
          dividendPerUnit,
          exNavAfterDistribution,
          fromDate,
          toDate
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getCorporateAnnouncementByID = async (
  email: string,
  amc_code: any,
  fund_code: any,
  announcement_id: any
) => {
  const url = `${Config.baseUrl}/corporateannouncements/get-unitholder-data-by-id-fund-for-process?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&announcement_id=${announcement_id}`;

  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getCorporateAnnouncementByID(
          email,
          amc_code,
          fund_code,
          announcement_id
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

//api for getting dividend announcements in dividend disbursement page

const getAllActiveUnpaidDividendAnnouncementsByFund = async (
  email: string,
  fund: any,
  paid: any,
  amc_code: string
) => {
  const url = `${Config.baseUrl}/corporateannouncements/get-announcements-by-paid?email=${email}&paid=${paid}&fund_code=${fund}&amc_code=${amc_code}`;

  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getAllActiveUnpaidDividendAnnouncementsByFund(
          email,
          fund,
          paid,
          amc_code
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const getDividendDisbursementsByAnnouncementId = async (
  email: string,
  amc_code: string,
  fund_code: string,
  announcement_id: string,
  announcement_number: string,
  draft?: string,
  paid?: string,
  reinvest?: string,
  page_number?: string,
  page_size?: string,
  folio?: string,
  unitholder_name?: string
) => {
  const url = `${Config.baseUrl}/dividend-disbursement/?email=${email}&amc_code=${amc_code}&fund_code=${fund_code}&announcement_id=${announcement_id}&announcement_number=${announcement_number}&draft=${draft}&paid=${paid}&page_number=${page_number}&page_size=20&reinvest=${reinvest}`;

  try {
    const result: any = await axios.get(url, {
      params: { folio_no: folio, search:unitholder_name },
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getDividendDisbursementsByAnnouncementId(
          email,
          amc_code,
          fund_code,
          announcement_id,
          announcement_number,
          draft,
          paid,
          page_number,
          page_size,
          folio
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const calculateDividendDisbursement = async (
  email: string,
  amc_code: any,
  fund: any,
  announcement_id: any,
  announcement_number: any,
  payment_account_code: any,
  payment_account_no: any,
  payment_account_title: any,
  payment_bank: any,
  payment_bank_branch: any,
  draft: any,
  paid: any,
  payment_proof: any,
  payment_date: any
) => {
  const url = `${Config.baseUrl}/dividend-disbursement/generate`;
  const token = sessionStorage.getItem("token");
  try {
    const result: any = await axios.post(
      url,
      {
        email,
        amc_code,
        fund_code: fund,
        announcement_id,
        announcement_number,
        payment_account_code,
        payment_account_no,
        payment_account_title,
        payment_bank,
        payment_bank_branch,
        draft,
        paid,
        payment_proof,
        payment_date,
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );

    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await calculateDividendDisbursement(
          email,
          amc_code,
          fund,
          announcement_id,
          announcement_number,
          payment_account_code,
          payment_account_no,
          payment_account_title,
          payment_bank,
          payment_bank_branch,
          draft,
          paid,
          payment_proof,
          payment_date
        );
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const handleUnitDisbursement = async (body: any) => {
  try {
    const response = await apiClient.post(
      "/dividend-disbursement/handle-unit-disbursement",
      body
    );

    if (response.data.status === 200) {
      // Assuming you have a state like setIsDisbursementHandled to track success
      toast.success("Unit disbursement handled successfully!");
      return true;
    } else if (response.data.status === 200) {
      // Assuming you have a state like setIsDisbursementHandled to track success
      toast.success(response.data.message);
      return false;
    } else {
      toast.error("Failed to handle unit disbursement");
    }
  } catch (error) {
    toast.error("Error handling unit disbursement");
    return false;
  }
};

const handleFinalize = async (body: any) => {
  try {
    const response = await apiClient.post(
      "/corporateannouncements/finalize-entitlements",
      body
    );

    if (response.data.status === 200) {
      // Assuming you have a state like setIsDisbursementHandled to track success
      toast.success(response.data.message || "Announcement Finalized!");
      return true;
    } else {
      toast.error(
        response.data.message || "Failed to handle unit disbursement"
      );
      return false;
    }
  } catch (error) {
    toast.error("Error handling unit disbursement");
    return false;
  }
};

const processPaymentRefund = async (body: any) => {
  try {
    const response = await apiClient.post(
      "/dividend-disbursement/mark-single-disbursement-paid",
      body
    );
    if (response.data.status === 200) {
      // Assuming you have a state like setIsDisbursementHandled to track success
      toast.success(
        response.data.message || "Unit disbursement handled successfully!"
      );
      return false;
    } else {
      toast.error(
        response.data.message || "Failed to handle unit disbursement"
      );
    }
  } catch (error: any) {
    toast.error(error.response.data.message || error.message);
  }
};

export {
  getAllDividendAnnouncements,
  getAllActiveUnpaidDividendAnnouncementsByFund,
  getCorporateAnnouncementByID,
  postToDividendAnnouncement,
  updateDividendAnnouncement,
  changeActiveStatus,
  changePaidStatus,
  getDividendDisbursementsByAnnouncementId,
  calculateDividendDisbursement,
  handleUnitDisbursement,
  processPaymentRefund,
  handleFinalize,
};
